import FormResetPassword from '../../components/FormResetPassword'
import usuarios from '../../api/usuarios'
import { useEffect, useState } from 'react'
import { useToast } from '../../hooks/toast'
import { useQueryParam, StringParam } from 'use-query-params'
import { useLocation } from 'react-router-dom'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'

function RedefinirSenha() {
  const [redirectUrl] = useQueryParam('redirectUrl', StringParam)

  const redirect = () => {
    window.location.href = redirectUrl || process.env.REACT_APP_URL_MAIN
  }

  // if (logged !== null) redirect()

  //Uso da interface URLSearchParams para separar a query string
  const getParams = new URLSearchParams(window.location.search)
  const token = getParams.get('token')
  const cid = getParams.get('cid')
  const { addToast } = useToast()
  const [data, setData] = useState('')

  //GET do endpoint de dados (Esqueci Minha Senha)
  const getUserData = async () => {
    await usuarios
      .getEsqueciSenha(token, cid)
      .then((response) => {
        if (!response.ok) {
          addToast({
            type: 'error',
            title: 'Token expirado ou inválido'
          })
          setTimeout(redirect, 2000)
        }
        return response.json()
      })
      .then((obj) => {
        setData(obj)
        return obj
      })
      .catch()
  }

  const location = useLocation()
    
  useEffect(() => {
    getLocalStorageLog(location.pathname)
    getUserData()
  }, [])

  return (
    <>
      {/* {logged === null && ( */}
      <FormResetPassword userData={data} redirect={redirect} />
      {/* )} */}
    </>
  )
}

export default RedefinirSenha
